/* eslint-disable tss-unused-classes/unused-classes */
import { makeStyles } from 'tss-react/mui';

export const useCommonStyles = makeStyles()((theme) => ({
  happyScaleContainer: {
    border: `1px solid ${theme.palette.text.secondary}`,
    borderRadius: theme.spacing(0.5),
  },
  happyScaleItem: {
    width: 50,
    height: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRight: `1px solid ${theme.palette.text.secondary}`,
    '&:first-of-type': {
      borderRadius: '3px 0 0 3px',
    },
    '&:last-of-type': {
      border: 'none',
      borderRadius: '0 3px 3px 0',
    },
    [theme.breakpoints.down('md')]: {
      width: 32,
      height: 32,
    },
  },
}));
